export var HistItemType;
(function (HistItemType) {
    HistItemType["VoucherCollection"] = "VOUCHER_COLLECTION";
    HistItemType["Interactions"] = "INTERACTIONS";
    HistItemType["Updates"] = "UPDATES";
    HistItemType["CaseCreation"] = "CASE_CREATION";
    HistItemType["CaseStatus"] = "CASE_STATUS";
    HistItemType["ConnectUpdate"] = "CONNECT_UPDATE";
})(HistItemType || (HistItemType = {}));
//# sourceMappingURL=itemTypes.js.map